import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCall,
  postCall,
  putCall,
  deleteCall,
  getById,
} from "../../utils/api";

const initialState = {
  data: [],
  error: "",
  status: "idle",
  isUpdateStatus: "idle",
};

export const getNetwork = createAsyncThunk(
  "Network/get",
  async ({ query = "", page = 1, per_page = 50 }) => {
    try {
      const response = await getCall(
        `/admin/v1/all_network?query=${query}&page=${page}&per_page=${per_page}`,
        false
      );
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const getNetworkById = createAsyncThunk(
  "Network/getById",
  async (id) => {
    try {
      const response = await getById("/admin/v1/show_network", id, false);
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const addNetwork = createAsyncThunk("Network/add", async (type) => {
  try {
    const response = await postCall("/admin/v1/add_network", type);
    return await response;
  } catch (error) {
    return Promise?.reject(error);
  }
});

export const updateNetwork = createAsyncThunk(
  "Network/update",
  async (Network) => {
    try {
      const { id, type } = Network;
      const response = await putCall(`/admin/v1/update_network/${id}`, {
        type: type,
      });
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const multipleDeleteNetwork = createAsyncThunk(
  "Network/delete",
  async (id, { dispatch }) => {
    try {
      await deleteCall(`/admin/v1/delete_network?network_id=${id}`);
      return await id;
    } catch (error) {
      return Promise?.reject(error);
    } finally {
    }
  }
);

const NetworkSlice = createSlice({
  name: "Network",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getNetwork.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getNetwork.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(getNetwork.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(getNetworkById.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getNetworkById.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(getNetworkById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(addNetwork.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addNetwork.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data.data.push(action.payload);
      })
      .addCase(addNetwork.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      .addCase(updateNetwork.pending, (state) => {
        state.isUpdateStatus = "loading";
        state.error = null;
      })
      .addCase(updateNetwork.fulfilled, (state, action) => {
        state.isUpdateStatus = "succeeded";
        const index = state.data.data.findIndex(
          (Network) => Network.id === action.payload.data.id
        );
        if (index >= 0) {
          state.data.data[index] = action.payload.data;
        }
      })
      .addCase(updateNetwork.rejected, (state, action) => {
        state.isUpdateStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      
      .addCase(multipleDeleteNetwork.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(multipleDeleteNetwork.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = state.data.data.filter(
          (Network) => Network.id !== action.payload
        );
      })
      .addCase(multipleDeleteNetwork.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message || "An unknown error occurred";
      });
  },
});

export default NetworkSlice.reducer;
